var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercleLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 13,
    viewBox: "0 0 65 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5250_32521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 0.5H0V12.5H65V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5250_32521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3412 0.5V5.55439H4.17188V0.5H7.3412Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3818 2.875V6.2133H0V2.875H10.3818Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81867 5.40137C8.49807 6.53359 10.3822 9.18162 10.3822 12.2613H7.03422C7.03422 10.6413 6.08846 9.23705 4.71875 8.5682",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46822 4.81445H4.12027C4.12027 7.07965 2.27175 8.92286 0 8.92286V12.2612C4.1173 12.2612 7.46748 8.92136 7.46748 4.81519L7.46822 4.81445Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4659 8.2106L62.9914 6.42059C62.4044 5.03782 60.7878 4.42367 59.4144 4.86859C58.1025 5.29354 57.1211 6.73247 57.4659 8.2106ZM64.9444 7.12639L57.8601 9.42185C58.6844 10.6945 60.1022 11.2222 61.4141 10.7973C62.417 10.4721 63.1908 9.65248 63.3938 8.59933L64.9993 8.07905C64.8977 10.0198 63.6577 11.6598 61.8211 12.2547C59.4137 13.0344 56.7884 11.5762 56.0583 9.33613C55.1956 6.68739 56.6305 4.18053 58.8993 3.4459C61.4149 2.63073 63.9505 3.91816 64.7339 6.32452C64.8177 6.58171 64.897 6.82411 64.9444 7.12639Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8001 12.2768H53.1406V0.5H54.8001V12.2768Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4688 9.36446H52.3202C51.6176 11.354 49.9262 12.4995 47.9628 12.4995C45.425 12.4995 43.4297 10.4627 43.4297 7.94768C43.4297 5.29005 45.3613 3.2207 47.9465 3.2207C49.9574 3.2207 51.7933 4.47783 52.3202 6.38755H50.4851C49.9899 5.35287 49.1917 4.73207 47.9947 4.73207C46.2551 4.73207 45.0899 6.05276 45.0899 7.85161C45.0899 9.65043 46.2869 10.9867 47.9628 10.9867C49.0961 10.9867 50.0055 10.3821 50.4688 9.36371V9.36446Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7853 12.2771H39.125V3.46016H40.6733V4.19699C40.6733 4.20956 40.683 4.21916 40.6956 4.21916C40.7015 4.21916 40.7074 4.21694 40.7118 4.21178C41.4427 3.43946 42.3988 3.2207 43.5848 3.2207V4.92348C41.9874 4.92348 40.7845 5.16884 40.7845 7.32688V12.2763L40.7853 12.2771Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8417 8.21992L36.2761 6.45949C35.6913 5.07598 34.0955 4.45517 32.7451 4.89269C31.4547 5.311 30.4941 6.74255 30.8417 8.21992ZM38.2039 7.17341L31.2368 9.43049C32.055 10.7046 33.4537 11.239 34.7441 10.8206C35.7306 10.5006 36.4888 9.68617 36.6838 8.63602L38.2625 8.12459C38.1721 10.0616 36.958 11.6927 35.1517 12.278C32.7837 13.0452 30.1903 11.5759 29.4609 9.33584C28.5974 6.68711 29.9997 4.19133 32.2315 3.46854C34.7055 2.66667 37.2093 3.96444 37.9935 6.3708C38.0772 6.62799 38.1566 6.8704 38.2047 7.17267L38.2039 7.17341Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6047 12.2928H13.8984L16.7282 4.82986C17.0811 3.80553 17.6644 3.16921 18.8837 3.16921C20.2393 3.16921 20.916 3.95334 20.916 5.12031V10.4193C20.916 10.7246 21.1065 10.9226 21.3755 10.9226C21.6201 10.9226 21.8099 10.777 21.8892 10.5501L24.1112 4.82764C24.4641 3.80627 25.0444 3.16699 26.2644 3.16699C27.62 3.16699 28.2967 3.95112 28.2967 5.1181V12.2884H26.6847V5.19939C26.6847 4.88012 26.4942 4.68131 26.2229 4.68131C25.9931 4.68131 25.8034 4.84095 25.7218 5.06636L23.4998 10.7888C23.1469 11.8102 22.5518 12.4495 21.3318 12.4495C19.991 12.4495 19.3143 11.6654 19.3143 10.4836V5.19939C19.3143 4.88012 19.1119 4.68131 18.84 4.68131C18.5953 4.68131 18.4323 4.84095 18.3389 5.06636L15.6032 12.2899L15.6054 12.2921L15.6047 12.2928Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercleLogoMobile);
export default __webpack_public_path__ + "static/media/mercle_logo_mobile.86678128925f48862195d5b5ad114abd.svg";
export { ForwardRef as ReactComponent };